import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.solidIcon.background.hover.custom(params);

export default custom;
